(function () {
    'use strict';

    angular
        .module('app')
        .controller('campaignFormController', campaignFormController);

    campaignFormController.$inject = ['$scope', 'campaignService', '$q', '$timeout'];
    function campaignFormController($scope, campaignService, $q, $timeout) {
        /* jshint validthis:true */
        var vm = this;
        var blockId, pageId;

        vm.formModel = getEmptyModel();

        vm.formSubmitted = false;
        vm.inProgress = false;
        vm.errorMsg = '';

        vm.init = init;
        vm.isInvalid = isInvalid;
        vm.submit = submit;

        //--------------------------------------------------------------------------------

        function init(pageid, blockid) {
            pageId = pageid;
            blockId = blockid;
            $scope.$watch('userForm.$dirty',
                // form chanegd from untoched to dirty 
                function (newValue, oldValue) {
                    if (newValue === true && oldValue === false) {
                        clearSubmitMessage();
                    }
                });
        }

        function clearSubmitMessage() {
            vm.formSubmitted = false;
            vm.errorMsg = '';
        }

        function isInvalid(form, field) {
            return ((form.$submitted || form[field].$touched) && form[field].$invalid === true);
        }

        function submit(form, $event) {
            if ($event) $event.preventDefault();

            if (!form.$valid || form.$valid === false) {
                var deferred = $q.defer();

                $timeout(function() {
                    form.$setSubmitted();
                    deferred.reject('form invalid');
                }, 500);

                return deferred.promise;
            }

            vm.errorMsg = '';
            vm.formSubmitted = false;
            vm.inProgress = true;

            return campaignService.submitCampaignForm(vm.formModel, pageId, blockId)
                .then(function(result) {
                    if (result.data === true) {
                        vm.formSubmitted = true;
                        vm.formModel = getEmptyModel();
                        form.$setPristine();
                        form.$setUntouched();
                    } else {
                        vm.errorMsg = 'error';
                    }
                })
                .catch(function() {
                    vm.errorMsg = 'error';
                })
                .finally(function() {
                    vm.inProgress = false;
                });
        }

        function getEmptyModel() {
            return {
                name: '',
                organization: '',
                email: '',
                phone: '',
                message: '',
                selectedOffice: null
            };
        }
    }
})();
